import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class SenderAddressPriceProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'prices/sender-address'

  getDefaultPrices(id: string) {
    return this.submit('get', `/${this.endpoint}/${id}/default`)
  }
}
